// extracted by mini-css-extract-plugin
export default {"section":"Skills_section__YKqRw","title":"Skills_title__DU1mm","list":"Skills_list__HPrIf"};